<div class="budget-settings-summary-chart" [class.is-overbudget]="isOverBudget">
  <div class="allocated-bar" [style.width]="allocatedPercentage + '%'"></div>
  <div class="total-bar"></div>
</div>
